'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _format2 = require('../../helpers/format');

var _format3 = _interopRequireDefault(_format2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link, LinkIcon } from '../'

var EsgConfig = {
  esgNamesLabels: [{
    label: 'Commodity producers',
    value: 'po_producer_weight'
  }, {
    label: 'Banks and lenders',
    value: 'po_financier_weight'
  }, {
    label: 'Major consumer brands',
    value: 'po_consumer_weight'
  }],
  esgOptions: {
    po_producer_weight: {
      id: 'po_producer_weight',
      icon: 'icons_step4',
      fieldLabel: 'po_producer_weight',
      benchLabel: 'po_producer_weight',
      valueLabel: 'Commodity producers',
      direction: 'ascending',
      page: 'producer-investments',
      label: 'in commodity producers',
      units: null,
      unitsExpanded: null,
      diffGood: function diffGood(diff) {
        return diff < 0;
      },
      diffStyle: function diffStyle(diff) {
        return diff > 0 ? 'higher-bad' : 'lower-good';
      },
      moreLess: function moreLess(diff) {
        return diff > 0 ? 'More invested' : 'Less invested';
      },
      format: function format(val) {
        return _format3.default.perc(val);
      },
      formatExpanded: function formatExpanded(val, moreLess, postiveNegative, url) {
        if (val === 0) {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'the same amount'
            ),
            ' invested in commodity producers'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'strong',
            { styleName: postiveNegative },
            _format3.default.perc(val),
            ' ',
            moreLess
          ),
          ' invested in commodity producers'
        );
      }
    },
    po_financier_weight: {
      id: 'po_financier_weight',
      icon: 'icons_step4',
      fieldLabel: 'po_financier_weight',
      benchLabel: 'po_financier_weight',
      valueLabel: 'Banks and lenders',
      direction: 'ascending',
      page: 'financier-investments',
      label: 'in banks and lenders',
      units: null,
      unitsExpanded: null,
      diffGood: function diffGood(diff) {
        return diff < 0;
      },
      diffStyle: function diffStyle(diff) {
        return diff > 0 ? 'higher-bad' : 'lower-good';
      },
      moreLess: function moreLess(diff) {
        return diff > 0 ? 'More invested' : 'Less invested';
      },
      format: function format(val) {
        return _format3.default.perc(val);
      },
      formatExpanded: function formatExpanded(val, moreLess, postiveNegative, url) {
        if (val === 0) {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'the same amount'
            ),
            ' invested in banks and lenders'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'strong',
            { styleName: postiveNegative },
            _format3.default.perc(val),
            ' ',
            moreLess
          ),
          ' invested in banks and lenders'
        );
      }
    },
    po_consumer_weight: {
      id: 'po_consumer_weight',
      icon: 'icons_step4',
      fieldLabel: 'po_consumer_weight',
      benchLabel: 'po_consumer_weight',
      valueLabel: 'Major consumer brands',
      direction: 'ascending',
      page: 'consumer-investments',
      label: 'in major consumer brands',
      units: null,
      unitsExpanded: null,
      diffGood: function diffGood(diff) {
        return diff < 0;
      },
      diffStyle: function diffStyle(diff) {
        return diff > 0 ? 'higher-bad' : 'lower-good';
      },
      moreLess: function moreLess(diff) {
        return diff > 0 ? 'More invested' : 'Less invested';
      },
      format: function format(val) {
        return _format3.default.perc(val);
      },
      formatExpanded: function formatExpanded(val, moreLess, postiveNegative, url) {
        if (val === 0) {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'the same amount'
            ),
            ' invested in major consumer brands'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'strong',
            { styleName: postiveNegative },
            _format3.default.perc(val),
            ' ',
            moreLess
          ),
          ' invested in major consumer brands'
        );
      }
    }
  }
};
// import config from '../../config'
exports.default = EsgConfig;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EsgConfig/EsgConfig.js
// module id = 1318
// module chunks = 0